// extracted by mini-css-extract-plugin
module.exports = {"NewLunchingline":"NewLunching_NewLunchingline__21-79","startYour":"NewLunching_startYour__e_TBp"};